import { render, staticRenderFns } from "./ProductSubClassDetail.vue?vue&type=template&id=4ece5d1b&scoped=true"
import script from "./ProductSubClassDetail.vue?vue&type=script&lang=js"
export * from "./ProductSubClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductSubClassDetail.vue?vue&type=style&index=0&id=4ece5d1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece5d1b",
  null
  
)

export default component.exports